<template>
  <!-- Rules List -->
  <div class=" rounded-lg shadow overflow-hidden">
    <div
      v-if="loading"
      class="p-6 text-center"
    >
      <i class="fas fa-spinner fa-spin text-xl text-gray-400 dark:text-gray-500" />
      <p class="mt-2 text-gray-600 dark:text-gray-400">
        Cargando reglas...
      </p>
    </div>

    <div
      v-else-if="!rules || rules.length === 0"
      class="p-6 text-center"
    >
      <i class="fas fa-truck text-2xl text-gray-300 dark:text-gray-600 mb-4" />
      <p class="text-gray-600 dark:text-gray-400">
        No hay reglas configuradas
      </p>
      <p class="text-sm text-gray-500 dark:text-gray-500 mt-2">
        Crea tu primera regla para comenzar a cobrar costo de envío
      </p>
    </div>

    <div v-else>
      <!-- Grid layout for desktop: 3 columns, Mobile: 1 column -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <RuleListItem
          v-for="rule in sortedRules"
          :key="rule.id"
          :rule="rule"
          :get-rule-type-label="getRuleTypeLabel"
          :format-rule-config="formatRuleConfig"
          @edit="editRule"
          @toggle-status="toggleRuleStatus"
          @delete="deleteRule"
        />
      </div>
    </div>
  </div>

  <!-- Create/Edit Modal -->
  <RuleFormModal
    :show="showCreateModal || showEditModal"
    :is-editing="showEditModal"
    :saving="saving"
    :current-rule="currentRule"
    @close="closeModal"
    @save="saveRule"
    @rule-type-change="onRuleTypeChange"
    @add-condition="addCondition"
    @remove-condition="removeCondition"
  />

  <!-- Delete Confirmation Modal -->
  <DeleteRuleConfirmationModal
    :show="showDeleteModal"
    :rule-name="ruleToDelete?.name || ''"
    @close="() => { deliveryFeeRules.showDeleteModal.value = false }"
    @confirm-delete="confirmDelete"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useDeliveryFeeRules } from '@/composables/useDeliveryFeeRules'
import RuleListItem from './RuleListItem.vue'
import RuleFormModal from './RuleFormModal.vue'
import DeleteRuleConfirmationModal from './DeleteRuleConfirmationModal.vue'

const deliveryFeeRules = useDeliveryFeeRules()

const {
  rules,
  loading,
  saving,
  showCreateModal,
  showEditModal,
  currentRule,
  ruleToDelete,
  sortedRules,
  loadRules,
  onRuleTypeChange,
  addCondition,
  removeCondition,
  closeModal,
  openCreateModal,
  editRule,
  saveRule,
  toggleRuleStatus,
  deleteRule,
  confirmDelete,
  getRuleTypeLabel,
  formatRuleConfig
} = deliveryFeeRules

// Acceder directamente a showDeleteModal para asegurar reactividad
const showDeleteModal = computed({
  get: () => deliveryFeeRules.showDeleteModal.value,
  set: (value) => { deliveryFeeRules.showDeleteModal.value = value }
})

defineExpose({
  openCreateModal
})
</script>
